import { render, staticRenderFns } from "./ImageRecognizer.vue?vue&type=template&id=708aeac1&scoped=true&"
import script from "./ImageRecognizer.vue?vue&type=script&lang=js&"
export * from "./ImageRecognizer.vue?vue&type=script&lang=js&"
import style0 from "./ImageRecognizer.vue?vue&type=style&index=0&id=708aeac1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708aeac1",
  null
  
)

export default component.exports